import { Expose, Transform, Type } from "class-transformer";
import { CreateDeliveryNoteLineDto } from "@/core/features/delivery-notes/create-delivery-note-line.dto";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class CreateDeliveryNoteDto {
  @Expose()
  code: string;

  @Expose()
  purchaseOrderIds: string[];

  @Expose()
  @Type(() => CreateDeliveryNoteLineDto)
  lines: CreateDeliveryNoteLineDto[];

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date: string;
}
